
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setLocale, getLocale, i18n } from 'core/i18n';
import Select from 'components/reactSelect';
import moment from 'moment';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/th';
import 'moment/locale/zh-tw';
import logoZH from 'assets/images/logo-zh-tw.png';
import logoJP from 'assets/images/logo-jp.png';
import logoKR from 'assets/images/logo-kr.png';
import logoTH from 'assets/images/logo-th.png';
import logoEN from 'assets/images/logo-en.png';

import {
  deleteSession,
  changeLanuage
} from './action';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    moment.locale('zh-tw');
  }
  
  render() {
    const self = this,
      {
        props
      } = self,
      {
        state,
        dispatch = () => { }
      } = props,
      { lang } = state;
    
    let logoImg = {
      'zh-tw': logoZH,
      'jp': logoJP,
      'kr': logoKR,
      'th': logoTH,
      'en': logoEN
    };

    return (
      <div className='header-container'>
        <div className='header-logo'>
          <a href={`https://www.tigerairtw.com/${getLocale()}`} target='_blank' rel='noopener noreferrer'>
            <img alt='' src={logoImg[getLocale()]} />
          </a>
        </div>
        <div className='header-right'>
          {
            sessionStorage.getItem('agentName') ? (
              <div className='header-user'>
                <span>{`${i18n('hello')},`}</span>
                <span>{sessionStorage.getItem('agentName')}</span>
              </div>
            ) : null
          }
          <div className='header-language'>
            <Select
              id={'headerLanguage'}
              // disabled={}
              // placeholder={}
              isSearchable={false}
              defaultValue={lang}
              options={[
                {
                  label: 'English',
                  value: 'en'
                }, {
                  label: '中文',
                  value: 'zh-tw'
                }
                // , {
                //   label: '日本語',
                //   value: 'jp'
                // }, {
                //   label: '한국어',
                //   value: 'kr'
                // }, {
                //   label: 'ไทย',
                //   value: 'th'
                // }
              ]}
              onChangeEvent={(data) => {
                setLocale(data.value);
                switch (data.value) {
                  case 'zh-tw':
                    moment.locale('zh-tw');
                    break;
                  case 'jp':
                    moment.locale('ja');
                    break;
                  case 'kr':
                    moment.locale('ko');
                    break;
                  case 'th':
                    moment.locale('th');
                    break;
                  case 'en':
                  default:
                    moment.locale('en');
                    break;
                }
                dispatch(changeLanuage(data,this.props));
              }}
            />
          </div>
          {
            sessionStorage.getItem('agentName') && sessionStorage.getItem('user') ? (
              <div className='header-logout' onClick={() => {
                dispatch(deleteSession(this.props));
              }}>
                <img alt='' src={require('assets/images/logout.svg')} />
              </div>
            ) : null
          }
        </div>
      </div>
    );
  }
};

let mapStateToProps = state => {
  return {
    state: state.mainReducer
  };
};

export default connect(mapStateToProps)(withRouter(Header));
